/* Private insurance screens (docs/plans/phase2-private-insurance.md §6). Tokens only;
 * states are words and shapes, never colour. */

.page {
  display: flex;
  flex-direction: column;
  gap: var(--space-5);
  min-width: 0;
}

.stack {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
}

.form {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
}

.fields {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: var(--space-3) var(--space-4);
}

.actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-3);
}

.id {
  font-family: var(--font-id);
  font-variant-numeric: tabular-nums;
}

.detail {
  font: var(--t-small);
  color: var(--graphite);
}

.sentence {
  font: var(--t-body-strong);
}

.table {
  width: 100%;
  border-collapse: collapse;
  font: var(--t-body);
}

.table th,
.table td {
  padding: var(--space-2) var(--space-3);
  border-bottom: 1px solid var(--rule);
  text-align: left;
  vertical-align: top;
}

.table th {
  color: var(--graphite);
  font: var(--t-micro);
  font-weight: 600;
  vertical-align: bottom;
}

.table tfoot td {
  font: var(--t-body-strong);
  border-bottom: none;
}

.number {
  text-align: right;
  font-variant-numeric: tabular-nums;
}

.table th.number,
.table td.number {
  text-align: right;
}

.list {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  margin: 0;
  padding: 0;
  list-style: none;
}

.row {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: var(--space-2) var(--space-3);
  padding: var(--space-2) 0;
  border-bottom: 1px solid var(--rule);
}

.row:last-child {
  border-bottom: none;
}

.grow {
  flex: 1 1 16rem;
  min-width: 0;
}

.facts {
  display: grid;
  grid-template-columns: max-content minmax(0, 1fr);
  gap: var(--space-1) var(--space-4);
  margin: 0;
}

.facts dt {
  color: var(--graphite);
}

.facts dd {
  margin: 0;
}

.signature {
  margin-top: var(--space-6);
  display: flex;
  gap: var(--space-6);
}

.signature span {
  flex: 1;
  padding-top: var(--space-2);
  border-top: 1px solid var(--ink);
  font: var(--t-small);
}
